import React, { useEffect, useState } from "react";
import DateSelect from "../utils/DateSelect";
import PointsSelect from "../utils/PointsSelect";
import Select from 'react-select';
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { fetchUsersByRole } from "../../action/user";
import { roleId } from "../../constants/app";
import { fetchFilials } from "../../action/handbook";
import { fetchDeletedUsersReport, setReportsFilters } from "../../action";
import moment from "moment";
import ErrorContainer from "../utils/ErrorContainer";
import Loader from "../utils/Loader";
import SortButton from "../utils/SortButton";
import { utils, writeFileXLSX } from "xlsx";
import MultiSelect from "../utils/MultiSelect";

const styles = {
    loading: {
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center'
    }
};

const detailOptions = [
    { label: 'Нет', value: 'none' },
    { label: 'День', value: 'day', notRender: [ 'year' ]},
    { label: 'Неделя', value: 'week', notRender: [ 'day', 'week' ]},
    { label: 'Месяц', value: 'month', notRender: [ 'day', 'week' ]},
];

function DetailRow ({item, color='#d5d4ff61', marginLeft = '0px' }) {
    return (
        <>
        <tr className='kt-datatable__row' style={{ backgroundColor: color }}>
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span style={{ marginLeft: marginLeft }}>{item.name}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{item.count || 0}</span></td>
        </tr>
        </>
    )
}

function ResultRow ({items}) {
    const resultCount = Object.values(items).reduce((acc, item) => {
        acc += item.count || 0;
        return acc;
    }, 0);

    return (
        <tr className='kt-datatable__row' style={{ backgroundColor: '#cfcfcf61'}}>
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span>ИТОГО</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{resultCount || 0}</span></td>
        </tr>
    )
}

function ItemRow ({item, detail}) {
    const [ showDetail, setShowDetail ] = useState(false);
    const renderDetail = detail && detail.value !== 'none' && !isEmpty(item.detailData);

    const handleClick = () => {
        if (!renderDetail) return;
        setShowDetail(!showDetail);
    }

    return (
        <>
        <tr onClick={handleClick} className='kt-datatable__row' style={(renderDetail) ? { cursor: 'pointer' } : {}}>
            {(renderDetail) && <td className='kt-datatable__cell' style={{ width: '12px'}}><i className={`kt-menu__ver-arrow la la-angle-${showDetail ? 'up' : 'down'}`} style={{ fontSize: '0.8rem' }}/></td>}
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span>{item.name}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{item.count || 0}</span></td>
        </tr>
        {(renderDetail) && showDetail && 
            Object.entries(item.detailData).map(([key, item]) => <DetailRow item={item} marginLeft='45px'/>)
        }
        </>
    )
}

export default function DeletedUsers() {
    const data = useSelector(state => state.reports.deletedUsers);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const pointLoading = useSelector(state => state.loaders.filials);

    const { result, filters, loading } = data;
    const [ regionalDirectors, setRegionalDirectors ] = useState([]);
    const [ _sort, setSort ] = useState({ field: 'name', sort: 'ASC'});
    const [ renderFilters, setRenderFilters ] = useState(filters);

    const dispatch = useDispatch();

    const [ detail, setDetail ] = useState({label: 'Нет', value: 'none'});

    const renderAdress = (item) => {
        if (!item) return 'Не определен';
        let cityName = null;
        if (item.city) {
            if (item.city.name) {
                cityName = item.city.name;
            } else {
                const entityPoint = points.find((point) => point.id === item.id);
                if (entityPoint) cityName = entityPoint.city.name || '---';
            }
        }
        return `${cityName ? cityName : '---'}, ${item.street}, ${item.house}`;
    };

    useEffect(() => {
        const getData = async () => {
            const regDirs = await dispatch(fetchUsersByRole({ role: roleId.regionalDirector }));
            const resultDirs = regDirs.map((dir) => ({ value: dir.id, label: dir.name ? dir.name : dir.username, points: dir.points })).sort((a, b) => a.label.localeCompare(b.label, 'ru'));
            setRegionalDirectors(resultDirs);
            if (!pointLoading && (isEmpty(points) || points.length < pointsCount)) await dispatch(fetchFilials(null, true));
        };
        
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClickSort = (newFiled) => {
        const { field, sort } = _sort;
        if (newFiled === field) {
            const newSort = sort === 'DESC' ? 'ASC' : 'DESC';
            setSort({field: _sort.field, sort: newSort});
        } else {
            setSort({field: newFiled, sort: 'ASC'});
        }
    }

    const onChangeDateSelect = (e) => {
        if (e && e.min && e.max) {
            const updated = { ...filters};
            updated.created_at_gte = new Date(e.min);
            updated.created_at_lte = new Date(e.max);
            dispatch(setReportsFilters('deletedUsers', updated));
        }
    }

    const setFilters = (field) => (data) => {
        const updated = { ...filters, [field]: data};
        dispatch(setReportsFilters('deletedUsers', updated));
    }

    const onSearch = () => {
        dispatch(fetchDeletedUsersReport({}, 'deletedUsers'));
        setRenderFilters(filters);
    }

    const getDetailOptions = () => {
        const date_gte = moment(filters.created_at_gte);
        const date_lte = moment(filters.created_at_lte);
        const diff = date_lte.diff(date_gte, 'days');
        let value = null;
        if (diff === 0) value = 'day';
        if (diff === 6) value = 'week';
        if (diff > 6 && diff < 180) value = 'month';
        if (diff >= 180) value = 'year';

        return value ? detailOptions.filter((item) => !item.notRender || !item.notRender.includes(value)) : detailOptions;
    }

    const isDisabledSearch = () => {
        if (loading) return true;
        if ((!filters.points || filters.points.length === 0) && (!filters.regionalDirectors || filters.regionalDirectors.length === 0)) return true;
        return false;        
    }

    const renderData = () => {
        if ((!result || result.length === 0) && (!renderFilters.points || renderFilters.points.length === 0) && (!renderFilters.regionalDirectors || renderFilters.regionalDirectors.length === 0)) return false;
        return true;       
    }

    const onExport = () => {
            const data = getGroupedData();
            const isRenderDetail = detail && detail.value !== 'none' && !isEmpty(data);
    
            const exportData = Object.entries(data).sort(([aKey, a], [bKey, b]) => {
                const { field, sort } = _sort;
                const aField = a[field || 'name'];
                const bField = b[field || 'name'];
                if (sort === 'DESC') {
                    if (typeof aField === 'string') {
                        if(aField.toLowerCase() > bField.toLowerCase()) return -1;
                        if(aField.toLowerCase() < bField.toLowerCase()) return 1;
                        return 0;
                    }
                    return bField - aField;  
                } else {
                    if (typeof aField === 'string') {
                        if(aField.toLowerCase() < bField.toLowerCase()) return -1;
                        if(aField.toLowerCase() > bField.toLowerCase()) return 1;
                        return 0;
                    }
                    return aField - bField;                                                        
                }
            }).flatMap(([firstKey, firstData]) => {
                if (!isRenderDetail) {
                    return { 
                        'Филиал': firstKey,
                        'Кол-во': firstData.count || 0,
                    };
                } else {
                    return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {
                        const dateText = detail === 'day' ? 'Дата' : 'Период';
                        return {
                            'Филиал': firstKey,
                            [dateText]: secondKey,
                            'Кол-во': secondData.count,
                        };
                    });
                }
            });

            const resultCount = Object.values(data).reduce((acc, item) => {
                acc += item.count || 0;
                return acc;
            }, 0);
                    
            exportData.push({
                'Филиал': 'ИТОГО',
                'Кол-во': resultCount,
            });
    
            const ws = utils.json_to_sheet(exportData);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, 'Клиенты');
            const detailText = [];
            const periodText = `${moment(renderFilters.created_at_gte).format('DD.MM.YYYY')} - ${moment(renderFilters.created_at_lte).format('DD.MM.YYYY')}`;
            detailText.push(periodText);
            if (isRenderDetail) detailText.push(`Детализация - ${detail.label || '-'}`);
            const resultText = detailText.join(', ');
            writeFileXLSX(wb, `Отчет удаленные клиенты ${resultText}.xlsx`);
        }

    const renderHead = () => {
        return(
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        Удаленные клиенты
                    </h3>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Поиск </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <label>Период *</label>
                        <DateSelect
                        isDisabled={loading}
                        isLoading={loading}
                        optionsDate={{
                            tommorow: true,
                            period: true,
                            prevWeek: true,
                            prevMonth: true,
                        }}
                        limit={{ 
                            field: 'months',
                            value: 6
                        }}
                        width={200}
                        onChange={onChangeDateSelect}
                        />
                    </div>
                    <div>
                        <label>Филиалы {(filters.regionalDirectors && filters.regionalDirectors.length > 0) ? '' : '*'}</label>
                        <PointsSelect width={200} placeholder='Филиалы' values={filters.points} setData={setFilters('points')} disabled={loading || (filters.regionalDirectors && filters.regionalDirectors.length > 0)}/>
                    </div>
                    <div style={{ width: 250 }}>
                        <label>Региональный директор {(filters.points && filters.points.length > 0) ? '' : '*'}</label>
                        <MultiSelect data={regionalDirectors} width={250} placeholder='Рег. директор' values={filters.regionalDirectors} setData={setFilters('regionalDirectors')} loading={loading} disabled={loading || (filters.points && filters.points.length > 0)}/>
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button disabled={isDisabledSearch()} onClick={onSearch} style={{ marginTop: '1.9rem' }} className="btn btn-primary">Найти</button>
                        {renderData() && <button disabled={loading} onClick={onExport} style={{ marginTop: '1.9rem' }} className='btn btn-dark btn-icon-sm'>Экспорт</button>}
                    </div>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Детализация </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <label>Уровень 1</label>
                        <Select
                            closeMenuOnSelect={true}
                            options={getDetailOptions()}
                            onChange={setDetail}
                            placeholder="Уровень 1"
                            noOptionsMessage={() => 'Нет'}
                            value={detail}                   
                        />
                    </div>
                </div>
            </div>
        );
    }

    const getGroupedData = () => {
        const getFirstKeys = () => {
            const keys = new Set();
            
            if (renderFilters.points && renderFilters.points.length > 0) {
                renderFilters.points.forEach(point => {
                    const dataPoint = points.find((p) => parseInt(p.id) === parseInt(point.value));
                    if (dataPoint && dataPoint) return keys.add(renderAdress(dataPoint));
                });
            } else if (renderFilters.regionalDirectors && renderFilters.regionalDirectors.length > 0) {
                renderFilters.regionalDirectors.forEach((dir) => {
                    if (dir && dir.points && dir.points.length > 0) dir.points.forEach((point) => {
                        if (point) {
                            let pointId = point.id ? point.id : point;
                            const dataPoint = points.find((point) => point.id === pointId);
                            return keys.add(renderAdress(dataPoint));
                        }
                        keys.add('Филиал не задан');
                    });
                })
            } else {
                result.forEach((order) => {
                    if (order && order.point) return keys.add(renderAdress(order.point));
                    keys.add('Филиал не задан');
                });
            }
            
            return Array.from(keys);
        };
    
        const getDateKeys = () => {
            if (detail.value === 'none') return [];
            
            const startDate = moment(renderFilters.created_at_gte);
            const endDate = moment(renderFilters.created_at_lte);
            const dateKeys = [];

            switch (detail.value) {
                case 'day': {
                    let current = startDate.clone();
                    while (current <= endDate) {
                        dateKeys.push(current.format('DD.MM.YYYY'));
                        current.add(1, 'day');
                    }
                    break;
                }
                case 'week': {
                    let current = startDate.clone().startOf('isoWeek');
                    let end = endDate.clone().endOf('isoWeek');
                    
                    while (current <= end) {
                        let weekStart = current;
                        let weekEnd = current.clone().endOf('isoWeek');

                        if (weekStart < startDate) {
                            weekStart = startDate.format('DD.MM.YYYY');
                        } else {
                            weekStart = weekStart.format('DD.MM.YYYY');
                        }
                        
                        if (weekEnd > endDate) {
                            weekEnd = endDate.format('DD.MM.YYYY');
                        } else {
                            weekEnd = weekEnd.format('DD.MM.YYYY');
                        }

                        dateKeys.push(`${weekStart} - ${weekEnd}`);
                        current.add(1, 'week');
                    }
                    break;
                }
                case 'month': {
                    let current = startDate.clone().startOf('month');
                    let end = endDate.clone().endOf('month');
                    
                    while (current <= end) {
                        const monthStart = current.format('DD.MM.YYYY');
                        const monthEnd = current.clone().endOf('month').format('DD.MM.YYYY');
                        dateKeys.push(`${monthStart} - ${monthEnd}`);
                        current.add(1, 'month');
                    }
                    break;
                }
                default: break;
            }
            
            return dateKeys;
        };
        
        const createData = () => {
            const firstKeys = getFirstKeys();
            const dateKeys = getDateKeys();
            
            const data = {};
            
            firstKeys.forEach(firstKey => {
                const firstData = {
                    name: firstKey,
                    count: 0,
                    detailData: {},
                    items: [],
                };
                
                if (detail.value !== 'none') {
                    dateKeys.forEach(dateKey => {
                        const dateData = {
                            name: dateKey,
                            count: 0,
                            items: []
                        };
                        
                        firstData.detailData[dateKey] = dateData;
                    });
                }
                
                data[firstKey] = firstData;
            });
            
            return data;
        };
        
        const getDateKeyUsers = (user) => {
            let time = 3;
            if (user && user.city && user.city.timeZone) time = parseInt(user.city.timeZone, 10) || 3; 
            const deletedDate = moment.utc(user.last_deleted_at).add(parseInt(time, 10), 'hours');
            switch(detail.value) {
                case 'day': {
                    return deletedDate.format('DD.MM.YYYY');
                }
                case 'week': {
                    const startDate = moment(renderFilters.created_at_gte);
                    const endDate = moment(renderFilters.created_at_lte);
                    let weekStart = deletedDate.clone().startOf('isoWeek');
                    let weekEnd = deletedDate.clone().endOf('isoWeek');
    
                    if (weekStart < startDate) {
                        weekStart = startDate.format('DD.MM.YYYY');
                    } else {
                        weekStart = weekStart.format('DD.MM.YYYY');
                    }
                
                    if (weekEnd > endDate) {
                        weekEnd = endDate.format('DD.MM.YYYY');
                    } else {
                        weekEnd = weekEnd.format('DD.MM.YYYY');
                    }
                    
                    return `${weekStart} - ${weekEnd}`;
                }
                case 'month': {
                    const monthStart = deletedDate.startOf('month').format('DD.MM.YYYY');
                    const monthEnd = deletedDate.endOf('month').format('DD.MM.YYYY');
                    return `${monthStart} - ${monthEnd}`;
                }
                default: {
                    return null;
                }
            }
        };
    
        const fillNullData = (data) => {
            const updated = JSON.parse(JSON.stringify(data));
            
            (result || []).forEach((user) => {
                const firstKey = user.point ? renderAdress(user.point) : 'Филиал не задан';
                
                if (updated[firstKey]) {
                    updated[firstKey].count += 1;
                    
                    if (detail.value !== 'none') {
                        const dateKey = getDateKeyUsers(user);
                        if (dateKey && updated[firstKey].detailData[dateKey]) {
                            const dateData = updated[firstKey].detailData[dateKey];
                            dateData.count += 1;
                            dateData.items.push(user);
                        }
                    }
                }
            });
            
            return updated;
        };
    
        const data = createData();
        const filledData = fillNullData(data);
        
        return filledData;
    };

    const renderTable = () => {
            const { field, sort } = _sort;
            const data = getGroupedData();
    
            return(
                <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded'>
                    <table className='kt-datatable__table' style={{ width: '100%'}}>
                        <thead className='kt-datatable__head' style={{ position: 'sticky' }}>
                            <tr className='kt-datatable__row'>
                                <th className='kt-datatable__cell' style={{ width: 'auto' }}>
                                    <SortButton
                                    className={field === 'name' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                    text='Наименование' onClick={() => handleClickSort('name')} 
                                    up={field === 'name' && sort === 'ASC'}
                                    />
                                </th>
                                <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                <SortButton 
                                    className={field === 'count' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                    text='Кол-во' 
                                    onClick={() => handleClickSort('count')} 
                                    up={field === 'count' && sort === 'ASC'}
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody className='kt-datatable__body'>
                            {Object.entries(data)
                            .sort(([aKey, a], [bKey, b]) => {
                                const { field, sort } = _sort;
                                const aField = a[field || 'name'];
                                const bField = b[field || 'name'];
                                if (sort === 'DESC') {
                                    if (typeof aField === 'string') {
                                        if(aField.toLowerCase() > bField.toLowerCase()) return -1;
                                        if(aField.toLowerCase() < bField.toLowerCase()) return 1;
                                        return 0;
                                    }
                                    return bField - aField;  
                                } else {
                                    if (typeof aField === 'string') {
                                        if(aField.toLowerCase() < bField.toLowerCase()) return -1;
                                        if(aField.toLowerCase() > bField.toLowerCase()) return 1;
                                        return 0;
                                    }
                                    return aField - bField;                                                        
                                }
                            })
                            .map(([key, item]) => <ItemRow item={item} detail={detail}/>)}
                            <ResultRow items={data}/>
                        </tbody>
                    </table>
                </div>
            );
        }

    const renderBody = () => {
        if (loading || pointLoading) return <div style={styles.loading}><Loader /></div>;        

        if (!renderData()) return <div className='kt-portlet'> 
            <div className='kt-portlet__body'>Нет данных</div> 
        </div>

        return(
        <div className="kt-portlet">
            <ErrorContainer field="deletedUsers" style={{ margin: '20px 20px 0px 20px' }} hasCloseButton={true}/>
            <div className='kt-portlet__body'>
            {renderTable()}    
            </div> 
        </div>
        );
    }

    return (
        <>
            <div className="kt-portlet">
                {renderHead()}
            </div>
            {renderBody()}
        </>         
    );
}